"use strict";

module.exports = ['$resource', function ( $resource ) {

    let Campaign = $resource('/campaigns/:id',
        {
            id: '@id'
        },
        {
            'save': {method:'POST'},
            'update': {method: 'PATCH'}
        }
    );

    var save = Campaign.save;

    // Required for "easy" .save in controllers
    Campaign.save = function ( ...args ) {

        if( args[0].id ) {
            this.update.apply(this, args);
        } else {
            save.apply(this, args);
        }
    };

    return Campaign;
}];
